import type { ICustomer } from '../../interfaces/src/shared/interfaces/customer-group';

export interface IActionObject<T> {
  type: string;
  payload?: T;
  error?: boolean;
  meta?: unknown;
}

export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const setCurrentUserAction = (
  user: ICustomer
): IActionObject<ICustomer> => ({
  type: SET_CURRENT_USER,
  payload: user
});
